import { SearchFormData } from '@/features/import_export_histories/type';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useParseSearchParams = (): Partial<SearchFormData> => {
  const [searchParams] = useSearchParams();
  const { getDateParam, getArrayParam } = useQueryParams();

  return useMemo(() => {
    const type = searchParams.get('type') || '';
    const source = searchParams.get('source') || '';
    const office_member_ids =
      getArrayParam(searchParams, 'office_member_ids') || [];
    const submitted_at_from = getDateParam(searchParams, 'submitted_at_from');
    const submitted_at_to = getDateParam(searchParams, 'submitted_at_to');

    return {
      type,
      source,
      office_member_ids,
      submitted_date: [submitted_at_from, submitted_at_to],
    };
  }, [searchParams, getDateParam, getArrayParam]);
};
